import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Our eCommerce Website <span>Design & Development</span> Services
            </h2>
            <p>
              We offer full-cycle eCommerce website development services for
              startups, scale-ups, and enterprises. Whether you need a digital
              shopping solution built from scratch or a makeover for your
              existing platform, our expert team is here to help.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Talk to Our Experts
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>eCommerce UI/UX Design</h4>
                  <p>
                    Create visually appealing, intuitive e-commerce interfaces
                    that drive user engagement and conversions. Our expert
                    designers craft responsive, mobile-first layouts with a
                    focus on seamless customer journeys across all devices.
                    Enhance user experiences with our data-driven UI/UX design
                    solutions.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>eCommerce Backend Development</h4>
                  <p>
                    Build robust, scalable, and secure backends for your
                    e-commerce platforms. Our full-stack developers leverage
                    modern frameworks and technologies to ensure fast, reliable,
                    and efficient performance. Optimize your site’s
                    functionality with our expert backend development services.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Headless Commerce Solutions</h4>
                  <p>
                    Implement highly flexible and scalable headless commerce
                    solutions. Decouple your frontend from backend systems for
                    enhanced performance and personalization. Leverage APIs to
                    deliver seamless, omnichannel shopping experiences and stay
                    ahead of the competition.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>eCommerce Platform Migration</h4>
                  <p>
                    Seamlessly migrate your online store to a more powerful and
                    scalable platform. Our migration experts handle everything
                    from data transfer to SEO preservation with zero downtime
                    and improved site performance. Upgrade to a robust
                    e-commerce platform effortlessly.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>API Integration Services</h4>
                  <p>
                    Enhance your e-commerce functionality with seamless
                    third-party API integrations. Connect your store with
                    payment gateways, CRM systems, and other essential tools.
                    Ensure smooth, real-time data flow and enrich your
                    platform’s capabilities with our integration services.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Custom Plugin Development</h4>
                  <p>
                    Extend your e-commerce store’s functionality with
                    tailor-made plugins. Our developers create custom solutions
                    to address your unique business needs, from advanced
                    analytics to specialized checkout processes. Enhance your
                    site’s performance with bespoke plugin development.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
